export default function Marquee({ phrases, testId = "marquee" }) {
    const content = phrases.map((p) => `${p} ✦`).join(" ");
    return (
        <div
            data-testid={testId}
            aria-hidden="true"
            className="relative z-[1] overflow-hidden border-y border-[#F3D085]/15 bg-[#130D24]/60 py-5 backdrop-blur-sm"
        >
            <div className="marquee-track">
                {[0, 1].map((n) => (
                    <span
                        key={n}
                        className="whitespace-nowrap px-4 font-display text-2xl font-light italic tracking-wide text-[#F3D085]/70 sm:text-3xl"
                    >
                        {content}&nbsp;
                    </span>
                ))}
            </div>
        </div>
    );
}
